import React from 'react';
import { Link } from 'react-router-dom';
import './ConversationList.css';

const ConversationList = ({ conversations, activeConversation, onSelectConversation }) => {
  // Ordenar conversaciones por fecha del último mensaje
  const sortedConversations = [...conversations].sort((a, b) => {
    const dateA = a.lastMessage ? new Date(a.lastMessage.sentAt) : new Date(0);
    const dateB = b.lastMessage ? new Date(b.lastMessage.sentAt) : new Date(0);
    return dateB - dateA; // Orden descendente (más reciente primero)
  });

  return (
    <div className="conversation-list">
      <div className="conversation-list-header">
        <h5 className="m-0">Conversaciones</h5>
        <Link to="/messages" className="btn btn-sm btn-outline-primary">
          <i className="fas fa-sync-alt"></i>
        </Link>
      </div>
      
      {sortedConversations.length === 0 ? (
        <div className="empty-conversations">
          <i className="far fa-comments text-muted"></i>
          <p>No tienes conversaciones</p>
        </div>
      ) : (
        <ul className="list-group conversation-items">
          {sortedConversations.map((conversation) => (
            <li
              key={conversation.id}
              className={`conversation-item list-group-item ${
                activeConversation && activeConversation.id === conversation.id
                  ? 'active'
                  : ''
              }`}
              onClick={() => onSelectConversation(conversation)}
            >
              <div className="conversation-avatar">
                {conversation.user.profilePicture ? (
                  <img 
                    src={conversation.user.profilePicture} 
                    alt={conversation.user.name} 
                    className="avatar-img"
                  />
                ) : (
                  <div className="avatar-initials">
                    {conversation.user.name.charAt(0).toUpperCase()}
                  </div>
                )}
                
                {conversation.unread > 0 && (
                  <span className="unread-badge">{conversation.unread}</span>
                )}
              </div>
              
              <div className="conversation-info">
                <div className="conversation-name">
                  {conversation.user.name}
                </div>
                
                <div className="conversation-task">
                  {conversation.task ? `Tarea: ${conversation.task.title}` : ''}
                </div>
                
                <div className="conversation-preview">
                  {conversation.lastMessage ? conversation.lastMessage.message : ''}
                </div>
                
                {conversation.lastMessage && (
                  <div className="conversation-time">
                    {formatMessageTime(conversation.lastMessage.sentAt)}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

// Función para formatear la hora del mensaje en un formato legible
const formatMessageTime = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  
  if (diffInDays === 0) {
    // Si es hoy, mostrar hora
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (diffInDays === 1) {
    // Si es ayer
    return 'Ayer';
  } else if (diffInDays < 7) {
    // Si es esta semana
    const options = { weekday: 'short' };
    return date.toLocaleDateString(undefined, options);
  } else {
    // Si es anterior
    const options = { month: 'short', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
};

export default ConversationList; 